import { Platform, StyleSheet } from 'react-native';
import { neutrals, brand } from 'src/theme/colors';

export const styles = StyleSheet.create({
  modalContainer: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    backgroundColor: brand.main.variations['lighterWater-3'],
    borderRadius: 0,
    padding: 0,
    margin: 0,
  },
  modalContent: {
    flex: 1,
    padding: 0,
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  contentWrapper: {
    flex: 1,
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
    backgroundColor: brand.main.variations['lighterWater-3'],
    zIndex: 1,
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  headerRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 38,
    minWidth: 145,
    borderRadius: 24,
    paddingHorizontal: 15,
    paddingVertical: 8,
    gap: 8,
    backgroundColor: neutrals.white,
    ...(Platform.OS === 'web' &&
      ({
        boxShadow: '9px 4px 19.4px 0 rgba(0,0,0,0.08)',
      } as any)),
  },
  backButtonText: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 24, //16* 150%
    color: neutrals.neutralGrays.tarmac,
  },
  mainContent: {
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 40,
  },
  productContainer: {
    flex: 1,
    width: '100%',
    maxWidth: 800,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 24,
    gap: 24,
  },
  topToolsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    paddingBottom: 24,
    zIndex: 1,
  },
  productWrapper: {
    flex: 1,
    width: '100%',
    maxHeight: '70%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  productWrapperMobile: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  bottomToolsContainer: {
    maxWidth: 350,
    paddingTop: 24,
  },
  iconButtonWrapperUndoRedo: {
    borderRadius: 24,
    padding: 8,
    width: 38,
    height: 38,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: neutrals.white,
    ...(Platform.OS === 'web' &&
      ({
        boxShadow: '9px 4px 19.4px 0 rgba(0,0,0,0.08)',
      } as any)),
  },
  iconButtonWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  sliderZoomContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  divider: {
    width: 1,
    height: 24,
    backgroundColor: neutrals.neutralGrays.dust,
  },
  rightIconsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  headerMobile: {
    width: '100%',
    backgroundColor: neutrals.white,
    paddingVertical: 14,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: neutrals.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    position: 'relative',
    zIndex: 2,
  },
  headerTitleMobile: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: '#252527',
  },
  bottomBarPlaceholder: {
    height: 258,
  },
  sliderContainer: {
    padding: 8,
  },
});
